import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {CalendarLocaleService} from '../../../../../../core/service/locale/calendar-locale.service';
import {Entity} from '../../../../../helpers/entity';
import {LeasedEmployeeStatCountService} from '../services/leased-employee-stat-count.service';

interface ChartData {
  labels: string[];
  datasets: { label: string, data: number[], fill: boolean, borderColor: string }[]
}

interface ChartOptions {
  title: {
    display: boolean,
    text: string
  },
  legend: {
    position: 'bottom'
  },
  scales: {
    xAxis: {
      min: number
    }
  }
}

@Component({
  selector: 'app-custom-staff-cockpit-stat-count-charts',
  styleUrls: ['./staff-cockpit-stat-count-charts.component.scss'],
  templateUrl: './staff-cockpit-stat-count-charts.component.html',
  providers: [CalendarLocaleService, LeasedEmployeeStatCountService]
})
export class StaffCockpitStatCountChartsComponent implements OnInit, OnDestroy {

  public isLoading = true;
  public unsubscribe = new Subject<void>();
  public data: { [userId: number]: ChartData} = {};
  public options: { [userId: number]: ChartOptions} = {};

  constructor(
    private calendarLocaleService: CalendarLocaleService,
    private cdr: ChangeDetectorRef,
    private leasedEmployeeStatCountService: LeasedEmployeeStatCountService
  ) {
  }

  ngOnInit(): void {
    this.leasedEmployeeStatCountService.getStats()
      .pipe(
        takeUntil(this.unsubscribe)
      ).subscribe((stats) => {
        this.data = this.buildData(stats);
        this.options = this.buildOptions(stats);
        this.isLoading = false;
        this.cdr.detectChanges();
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  private buildData(stats): { [userId: number]: ChartData } {
    const data = {};

    for (const stat of stats) {
      const userId = Entity.getValue(stat, 'user.id');

      if (!data[userId]) {
        data[userId] = {
          labels: [...Array(52).keys()].map(i => (i + 1).toString()),
          datasets: [
            {
              label: 'Plan',
              data: [],
              fill: false,
              borderColor: '#3883cb'
            },
            {
              label: 'Ist',
              data: [],
              fill: false,
              borderColor: '#e09354'
            }
          ]
        };
      }

      data[userId].datasets[0].data[stat.currentWeek - 1] = stat.plannedValue;
      data[userId].datasets[1].data[stat.currentWeek - 1] = stat.realValue;
    }

    return data;
  }

  private buildOptions(stats): { [userId: number]: ChartOptions } {
    const options = {};

    for (const stat of stats) {
      const userId = Entity.getValue(stat, 'user.id');
      const userFullName = `${Entity.getValue(stat, 'user.firstName')} ${Entity.getValue(stat, 'user.lastName')}`;

      options[userId] = {
        title: {
          display: true,
          text: `Mitarbeiter ${userFullName}`
        },
        legend: {
          position: 'bottom'
        },
        scales: {
          xAxis: {
            min: 0,
          }
        }
      }
    }

    return options;
  }
}

